import { useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from '@/shared/services/queryClient';
import {
  batchesApi,
  type CreateBatchRequest,
  type UpdateBatchRequest,
} from '../services/batchesApi';

export const useBatchesByInput = (inputId: string) => {
  return useQuery({
    queryKey: ['batches', inputId],
    queryFn: () => batchesApi.getBatchesByInput(inputId),
    enabled: !!inputId, // Only run if inputId is truthy
  });
};

export const useExpiringBatches = (daysAhead: number = 30) => {
  return useQuery({
    queryKey: ['batches', 'expiring', daysAhead],
    queryFn: () => batchesApi.getExpiringBatches(daysAhead),
  });
};

export const useExpiredBatches = () => {
  return useQuery({
    queryKey: ['batches', 'expired'],
    queryFn: batchesApi.getExpiredBatches,
  });
};

export const useCreateBatch = (inputId: string) => {
  return useMutation({
    mutationFn: (payload: CreateBatchRequest) =>
      batchesApi.createBatch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches', inputId] });
    },
  });
};

export const useUpdateBatch = (inputId: string) => {
  return useMutation({
    mutationFn: (payload: UpdateBatchRequest) =>
      batchesApi.updateBatch(payload.id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches', inputId] });
      queryClient.invalidateQueries({ queryKey: ['batches', 'expiring'] });
    },
  });
};

export const useDeleteBatch = (inputId: string) => {
  return useMutation({
    mutationFn: (id: string) => batchesApi.deleteBatch(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches', inputId] });
      queryClient.invalidateQueries({ queryKey: ['batches', 'expiring'] });
    },
  });
};